import * as React from "react";
import { IDevelopmentFormProps } from "./DevelopmentForm2";
export const DevelopmentFormContext = React.createContext<Partial<IDevelopmentFormProps>>(undefined);